import type {DispatchReportJob} from './schemas'

export function formatAssetAssignment(
    assignment: DispatchReportJob['assetAssignments'][number],
    quantitySeparator = '×',
): string {
    if (assignment.quantity != null && assignment.rentalAssetTypeName) {
        return `${assignment.quantity}${quantitySeparator} ${assignment.rentalAssetTypeName}`
    }
    return assignment.rentalAssetName ?? '—'
}
